import { Link } from '@mui/material';

import { QUESTIONNAIRE_ID_LINK_SX } from '../styles';

import type { QuestionnaireIdLinkProps } from '../types';

function QuestionnaireIdLink({ path, label }: QuestionnaireIdLinkProps) {
  return (
    <Link href={path} target="_blank" rel="noopener noreferrer" sx={QUESTIONNAIRE_ID_LINK_SX}>
      {label}
    </Link>
  );
}

export default QuestionnaireIdLink;
